import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["startInput", "endInput", "durationHint", "submitButton"];

  connect() {
    this.updateDuration();
  }

  updateDuration() {
    if (!this.hasStartInputTarget || !this.hasEndInputTarget) return;

    const startValue = this.startInputTarget.value;
    const endValue = this.endInputTarget.value;

    if (!startValue || !endValue) {
      this.durationHintTarget.textContent = "Duration: --";
      this.durationHintTarget.classList.remove("text-danger");
      this.toggleSubmit(false);
      return;
    }

    const start = new Date(startValue);
    const end = new Date(endValue);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      this.durationHintTarget.textContent = "Duration: --";
      this.durationHintTarget.classList.add("text-danger");
      this.toggleSubmit(false);
      return;
    }

    const durationMinutes = Math.round((end - start) / 60000);
    const durationHours = durationMinutes / 60;
    this.durationHintTarget.textContent = `Duration: ${durationHours.toFixed(2)} hours`;

    const valid = durationMinutes >= 60 && durationMinutes <= 1440;
    this.durationHintTarget.classList.toggle("text-danger", !valid);
    this.toggleSubmit(valid);
  }

  toggleSubmit(enabled) {
    if (!this.hasSubmitButtonTarget) return;
    this.submitButtonTarget.disabled = !enabled;
  }
}
